var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "app-container" }, [
    _c("div", [_vm._v("\n\t\t" + _vm._s(_vm.loggedInUserInfo) + "\n\t")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }